// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cb03d50d","581":"6253719e"}[chunkId] + ".chunk.js";
};